// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderDashboardMobileMenu_container__NnGWn","linkMenu":"HeaderDashboardMobileMenu_linkMenu__a18Ga"};